import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import MahendraOla from "../../assets/MahendraOla.jpeg";
import School from "../../assets/ShreeSchool.jpeg";
import PageTitle from "../../Components/PageTitle";

const PrincipalDesk = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Message from the Principal - Shree Mangalam School"
        description="Read the inspiring message from the Principal of Shree Mangalam School. A vision of discipline, excellence, and dedication towards preparing future leaders through RIMC, Sainik, and Military School coaching."
        url="/principal-desk"
        keywords="principal's message, principal desk, Shree Manglam principal, school leadership, educational vision, RIMC coaching inspiration"
      />

      <Header image={School} alt={"Shree Mangalam School"} />
      <Container
        // sx={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}
        sx={{ mb: 5, mt: 5 }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Principal Desk
        </Typography>
        <Grid container spacing={3} mt={3}>
          {/* Image Section - 4 columns */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                backgroundColor: "#C49A4B",
                padding: "1rem",
                borderRadius: "8px",
                mt: { xs: 0, md: 9 },
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "1.5rem",
                }}
              >
                <img
                  src={MahendraOla}
                  alt="Principal Mahendra Ola"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    mt: -2,
                    fontWeight: "bold",
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                  }}
                >
                  Principal:{" "}
                  <span
                    style={{
                      color: "#AD1C86",
                      fontWeight: "bold",
                      fontStyle: "italic",
                      fontSize: "1.1rem",
                    }}
                  >
                    Mr.Mahendra Ola
                  </span>
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Content Section - 8 columns */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  // fontSize: "25px",
                  letterSpacing: 1,
                  color: "#AD1C86",
                  fontWeight: "bold",
                }}
              >
                Dear Parents,
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                It is with great pride and humility that I serve as the
                Principal of Shree Mangalam School, an institution
                dedicated to nurturing students who embody knowledge, integrity,
                creativity, and a deep love for our culture and heritage. Our
                mission is clear: "To empower learners with skills, values, and
                innovation, while fostering a deep connection to Indian
                civilization, heritage, and a spirit of service to humanity."
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                At Shree Mangalam School, we are committed to providing an
                enriching and supportive environment in every classroom. Our
                goal is to challenge students to reach their highest potential,
                instilling a sense of responsibility and community. We believe
                that each student has unique talents and abilities, and we
                encourage them to use these gifts to serve others, contributing
                meaningfully to society.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Our teaching philosophy recognizes the individuality of each
                student. We employ diverse teaching strategies that cater to
                students' strengths and provide opportunities for growth in
                areas that require improvement. This holistic approach ensures
                that every student can excel in their own way.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                In this rapidly evolving world, we are dedicated to ensuring
                that our students are equipped for the future. At Shree Mangalam
                School, we embrace cutting-edge educational practices,
                introducing our students to areas like coding, robotics, and
                engineering. What were once niche subjects are now integrated
                into our curriculum, helping students develop skills that are
                critical in the 21st century.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                As a forward-thinking institution, we are aligning our teaching
                methods with the New Education Policy-2020, focusing on
                inquiry-based, discovery-based, discussion-based, and
                analysis-based learning. Our aim is to foster creativity,
                critical thinking, motor skills, communication abilities, and a
                lifelong love for learning.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                We highly value the involvement of parents and the community in
                the educational journey of our students. Together, we can
                achieve new milestones and help our children reach their fullest
                potential.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                In closing, I am reminded of the words of Henry Ford: "Coming
                together is a beginning, staying together is progress, and
                working together is success." Let us join hands to create a
                future full of possibilities and excellence for our students.
              </Typography>

              <Box sx={{ fontStyle: "italic" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                  }}
                >
                  With best wishes to all,
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                    color: "#AD1C86",
                  }}
                >
                  Mr.Mahendra Ola
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                  }}
                >
                  Principal
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default PrincipalDesk;
